<p-dialog
  header="Resgate seu CUPOM"
  [visible]="true"
  [modal]="true"
  [style]="{ width: '35vw', height: '60vh' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onClickClose()"
  [(visible)]="visible"
>
  <h2>Que tal 4% de desconto na sua primeira compra?</h2>
  <h3>
    Cadastre-se agora e ganhe 4% de desconto na sua primeira compra a vista
  </h3>
  <div class="inputs">
    <input
      type="text"
      placeholder="Seu nome..."
      name="name"
      pInputText
      [(ngModel)]="couponData.name"
      [ngClass]="{
        'error-input': couponError.errorName
      }"
    />
    <input
      type="text"
      placeholder="Seu e-mail..."
      required
      pInputText
      name="email"
      [(ngModel)]="couponData.email"
      [ngClass]="{
        'error-input': couponError.errorEmail
      }"
    />
    <p-inputMask
      mask="(99) 99999-9999"
      name="phone"
      [(ngModel)]="couponData.phone"
      placeholder="Seu telefone com DDD..."
      [ngClass]="{
        'error-input-mask': couponError.errorPhone
      }"
    ></p-inputMask>
  </div>

  <button *ngIf="!showCoupon" (click)="onClickCoupon()">QUERO MEU CUPOM</button>

  <h4 *ngIf="showCoupon">4PRIMEIRACOMPRA</h4>

  <p>
    *Ao se cadastrar, você concorda com nosso
    <a target="_blank" href="aviso-de-privacidade">Aviso de Privacidade!</a>
  </p>
</p-dialog>
